import React from "react";

import { useTranslation } from "react-i18next";
import { Box, CircularProgress, Tooltip, Typography } from "@mzc-pdc/ui";
import { alpha } from "@mui/material";
import theme from "@styles/theme";

export const AssetStatusRestoring = () => {
    const { t } = useTranslation();

    return (
        // className 을 붙이지 않는 이유는 AssetStatusArchiving 주석 참고.
        <Box
            sx={{
                position: `absolute`,
                left: 0,
                top: 0,
                zIndex: 1,
                width: `100%`,
                height: `100%`,
                display: `flex`,
                flexDirection: `column`,
                alignItems: `center`,
                justifyContent: `center`,
                backgroundColor: alpha(theme.palette.secondary[50], 0.9),
            }}
        >
            <Tooltip
                open={true}
                color={"primary"}
                title={
                    <Typography variant={"body3_700"} textTransform={"uppercase"}>
                        {t(`common::label::Restoring...`)}
                    </Typography>
                }
            >
                <CircularProgress color="primary" size={16} />
            </Tooltip>
        </Box>
    );
};

export default React.memo(AssetStatusRestoring);
